import AllPurchasesContributions from './AllPurchasesContributions';

export default AllPurchasesContributions;
